// extracted by mini-css-extract-plugin
export default {"table":"ForecastHistory_table__1rxHW","table_estimated":"ForecastHistory_table_estimated__eODL9"};